export default __webpack_public_path__ + "static/media/frames_grid_creation_icon.afbae438.svg";